import Modal from 'react-modal';
import { Close } from '@shared/assets';
import { Card, IconButton } from '@shared/ui';
import * as st from './styles.module.scss';

interface Props {
  isOpen: boolean;
  onToggle: () => void;
}

const ActionList = () => (
  <ul className={st.list}>
    <li className={st.list__item}>Отправить сообщение</li>
    <li className={st.list__item}>Рекомендовать товар</li>
    <li className={st.list__item}>Пригласить на мероприятие</li>
    <li className={st.list__item}>Рекомендовать видео</li>
    <li className={st.list__item}>Рекомендовать программу</li>
    <li className={st.list__item}>Рекомендовать статью</li>
    <li className={st.list__item}>Импортировать в vcf</li>
    <li className={st.list__item}>Импортировать в Excel</li>
  </ul>
);

export const ActionsModal = ({ isOpen, onToggle }: Props): JSX.Element => {
  return (
    <Modal isOpen={isOpen} className={st.viewer} overlayClassName={st.overlay}>
      <Card className={st.modal}>
        <div className={st.modal__header}>
          <IconButton className={st.close} variant="white" onClick={onToggle}>
            <Close />
          </IconButton>
          <span className={st.title}>Выберите действие</span>
        </div>
        <ActionList />
      </Card>
    </Modal>
  );
};
